import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import TranslateManager from 'ts-translate-js';
import { CreateReactClassComponent } from '../../../types/createreactapp';
import { BuyTicketPromoInfoModel, BuyTicketPromoInfoModelBase } from '../../../mvcapi/models/buyticket/buy-ticket-promo-info-model';
import { BuyPackagePromoInfoModel } from '../../../mvcapi/models/buypackage/buy-package-promo-info-model';
import { includes } from 'lodash';

const tr = TranslateManager.boundTR;

const PACKAGEIDSFORCREDITCARDCONDITION = [1825];
// **** Pour supporter une promo en mode numéro de carte (evenement) ****
const EVENTIDSFORCREDITCARDCONDITION = [10952];
// **********************************************************************

interface PromoPasswordInputPanelProps {
    promoInfo: BuyTicketPromoInfoModelBase;
    onPromoInfoUpdated: (promoInfo: BuyTicketPromoInfoModelBase) => void;
    onContentChange: () => void;
}

interface PromoPasswordInputPanelState {
    promoPassword: string;
    promoInfo: BuyTicketPromoInfoModelBase;
    checkingPromoPassword: boolean;
    promoPasswordTried: boolean;
    promoPasswordConditionOk: boolean;
}

type PromoPasswordInputPanelInterface = CreateReactClassComponent<typeof PromoPasswordInputPanelDef, PromoPasswordInputPanelProps, PromoPasswordInputPanelState>;

const PromoPasswordInputPanelDef = {
    displayName: "PromoPasswordInputPanel",

    propTypes: {
        //promoInfo: PropTypes.object,
        onPromoInfoUpdated: PropTypes.func,
        onContentChange: PropTypes.func
    },

    getInitialState: function() {
        return {
            promoPasswordTried: false,
            promoPasswordConditionOk: true
        };
    },

    raiseContentChanged: function() {
        const _this: PromoPasswordInputPanelInterface = this;
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(_this.props.onContentChange !== undefined) _this.props.onContentChange();
        }.bind(_this), 0);
    },

    componentDidMount: function() {
        const _this: PromoPasswordInputPanelInterface = this;
        _this.raiseContentChanged();
    },

    componentDidUpdate: function() {
        const _this: PromoPasswordInputPanelInterface = this;
        _this.raiseContentChanged();
    },
     
    handlePromoPasswordChange(e){
        const _this: PromoPasswordInputPanelInterface = this;
        _this.setState({ promoPassword: e.target.value }); 
    },

    handlePromoPasswordSubmit(e){
        const _this: PromoPasswordInputPanelInterface = this;
        e.preventDefault(); e.stopPropagation();

        _this.setState({ checkingPromoPassword: true, promoPasswordTried: false });
        
        const promoPassword = _this.state.promoPassword;
        const packageId = (_this.props.promoInfo as BuyPackagePromoInfoModel)?.packageID;
        const  isPackage = packageId != null && packageId != 0;
        console.log("Package : ", packageId, isPackage);

        const passwordcheck = true;

        if(passwordcheck) {
            if(!isPackage) {
                _this.loadPromoInfoRequest = tsapp.mvcapi.postCtl("buyticket/promopasswordcheck", { password: promoPassword })
                                                 .success((data) => _this.promoPasswordCheck_success(data));
            }
            else {
                _this.loadPromoInfoRequest = tsapp.mvcapi.postCtl("buypackage/promopasswordcheck", { password: promoPassword })
                                                 .success((data) => _this.promoPasswordCheck_success(data));
            }
        }
        
    },

    promoPasswordCheck_success(data) {
        const _this: PromoPasswordInputPanelInterface = this;
        const promoInfo = data.promoInfo as BuyTicketPromoInfoModelBase;
        _this.setState({
            promoPassword: "",
            promoInfo: promoInfo,
            checkingPromoPassword: false,
            promoPasswordTried: true // _this is used to display a message when the user failed to enter the correct password.
        });
        _this.raiseContentChanged();
        _this.props.onPromoInfoUpdated(promoInfo);
    },
    
    render() {
        const _this: PromoPasswordInputPanelInterface = this;
        let isInPromoMode, promoPasswordNeeded;
        
        // Promo title and password
        isInPromoMode = _this.props.promoInfo != null;
        promoPasswordNeeded = isInPromoMode && _this.props.promoInfo.passwordNeeded;
        if(isInPromoMode) {
            let promoTitlePanel;
            let promoPasswordInputPanel;

            if(_this.props.promoInfo.found) {
                promoTitlePanel = <h3>{_this.props.promoInfo.name}</h3>;

                if(promoPasswordNeeded) {
                    let promoPasswordCreditCardError;
                    let errorMessage = tr("Mot de passe incorrect");
                    let question = tr("Veuillez entrer le code de promotion");
                    if (includes(PACKAGEIDSFORCREDITCARDCONDITION, (_this.props.promoInfo as BuyPackagePromoInfoModel).packageID
                        || includes(EVENTIDSFORCREDITCARDCONDITION, (_this.props.promoInfo as BuyTicketPromoInfoModel).eventID))) {       
                    // if(PACKAGEIDSFORCREDITCARDCONDITION.indexOf((_this.props.promoInfo as BuyPackagePromoInfoModel).packageID) >= 0
                    //     || EVENTIDSFORCREDITCARDCONDITION.indexOf((_this.props.promoInfo as BuyTicketPromoInfoModel).eventID) >= 0) {
                        question = tr("Veuillez entrer les 4 premiers chiffres de votre carte de débit Desjardins");

                        errorMessage = tr("Numéro de carte invalide!");
                    }
                    // If the password was tried once but is still needed, we show a message
                    promoPasswordCreditCardError = !_this.state.promoPasswordConditionOk
                                                     ? <div className="alert alert-danger">{tr("Numéro de carte invalide!")}</div>
                                                     : null;
                    
                    // If the password was tried once but is still needed, we show a message
                    let promoPasswordError = _this.state.promoPasswordTried
                                           ? <div className="alert alert-danger">{errorMessage}</div>
                                           : null;
                    
                    promoPasswordInputPanel = (
                        <div className="col-xs-12 text-center">
                            <form onSubmit={_this.handlePromoPasswordSubmit}>
                                <div >
                                    <label htmlFor="promoPasswordInputField">{question}</label>
                                </div>
                                <div className="form-inline">
                                    <div className="form-group">
                                        <input id="promoPasswordInputField" className="form-control" type="password" autoComplete="off" onChange={_this.handlePromoPasswordChange} value={_this.state.promoPassword} placeholder={tr("code promo")} />
                                    </div>
                                    <div className="form-group">
                                        <button className="pull-right btn btn-primary" type="submit">Valider</button>
                                    </div>
                                </div>
                                
                                <div className="col-xs-12 col-sm-4 col-sm-offset-4">
                                    {promoPasswordError}
                                    {promoPasswordCreditCardError}
                                </div>
                            </form>
                        </div>
                    );
                }
            }
            else
                promoTitlePanel = <h3>{tr("Promotion non trouvée")}</h3>;

            return (
                <div className="row">
                    <div className="col-xs-12 text-center">{promoTitlePanel}</div>
                    {promoPasswordInputPanel}
                </div>
            );

        }
    }
};

export const PromoPasswordInputPanel = createClass<PromoPasswordInputPanelProps>(PromoPasswordInputPanelDef);